import { Injectable, inject } from '@angular/core';
import { getTechnicalErrorMessageKey } from '@api/errors/constants/technical-error-message-keys.constant';
import { AppError } from '@api/errors/models/app-error.types';
import { NotificationService } from '@fnccr-actee/design-system';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TechnicalErrorHandler {
  private readonly _notification = inject(NotificationService);
  private readonly _translate = inject(TranslateService);

  handle(error: AppError): void {
    this._notification.error({
      label: this._translate.instant('errors.title'),
      description: this._translate.instant(getTechnicalErrorMessageKey(error.status)),
    });
  }
}
